var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductRemove({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.73438 15.9844V4.73438H12.2344V15.9844C12.2344 16.2995 12.1229 16.582 11.8447 16.8603C11.5664 17.1385 11.2839 17.25 10.9688 17.25H3C2.68486 17.25 2.40233 17.1385 2.12408 16.8603C1.84583 16.582 1.73438 16.2995 1.73438 15.9844Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9688 3V0.984375H10.5L9.46875 0H4.5L3.46875 0.984375H0V3H13.9688Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductRemove);
export default __webpack_public_path__ + "static/media/productRemove.9d759668acdfda90c59e722c102338a8.svg";
export { ForwardRef as ReactComponent };